import { render, staticRenderFns } from "./SettingsLimit.vue?vue&type=template&id=5294847d&"
import script from "./SettingsLimit.vue?vue&type=script&lang=js&"
export * from "./SettingsLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports